<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        All Fixed Accounts {{ TotalFixeExpense.toLocaleString() }}
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          outlined
          solo
          append-icon="fas fa-search"
          label="Search"
          dense
          single-line
          hide-details
        ></v-text-field>
        <v-btn
          v-if="CustomersList.length"
          icon
          class="d-print-none ml-5"
          small
          color="success"
          @click="PrintPage"
        >
          <v-icon>fas fa-print</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :no-data-text="noData"
          :loading="isLoading"
          :headers="headers"
          :items="CustomersList"
          :search="search"
        >
          <template v-slot:[`item.Amount`]="{ item }">
            {{ item.Amount.toLocaleString() }}
          </template>

          <template v-slot:[`item.more`]="{ item }">
            <base-row-layout>
              <!-- Edite icon -->
              <div>
                <v-btn icon color="primary">
                  <v-icon class="mr-2" @click="EditeExpense(item)">
                    fas fa-pencil-alt
                  </v-icon>
                </v-btn>
              </div>
              <!-- Show Balance icon -->
              <div>
                <ShowBalance
                  :key="item._id + 'Balance'"
                  :ReqURL="`/expense/fixed/balance`"
                  :Title="item.expensName"
                  :query="{ _id: item._id }"
                >
                </ShowBalance>
              </div>
              <!-- Transaction View Icon -->
              <div>
                <ExpenseTran
                  BaseURL="/expense/fixed"
                  :Title="item.expensName"
                  :TranInfo="item"
                >
                  <template v-slot:Ref="{ row: item }">
                    <base-row-layout
                      v-if="item && item.Ref.search(/^CHR-/) == -1"
                    >
                      <!-- Fixed Expens Delete Icon -->

                      <div>
                        <BaseDelete
                          v-if="UsersToken.UserType === 'Admin'"
                          :OnFinish="
                            () => {
                              item.OnSearch(item.fromDate, item.toDate);
                            }
                          "
                          :DelQuery="{ Ref: item.Ref }"
                          DelUrl="/Reports/deleteRef"
                        >
                          <template #title>
                            DELETE
                            <span class="black--text">{{
                              item.Description
                            }}</span>
                          </template>

                          <v-row>
                            <v-col>{{ item.date }}</v-col>

                            <v-col>{{ item.Details }}</v-col>
                            <v-col>{{
                              item.Amount && item.Amount.toLocaleString()
                            }}</v-col>
                          </v-row>
                        </BaseDelete>
                      </div>
                      <!-- Edite Date and Details -->
                      <div>
                        <base-edite-date
                          :Info="item"
                          BaseURL="/expense"
                          :FinishedWithdrow="
                            () => {
                              item.OnSearch(item.fromDate, item.toDate);
                            }
                          "
                        ></base-edite-date>
                      </div>
                    </base-row-layout>
                    <div v-else>
                      <p>Can't dell</p>
                    </div>
                  </template>
                </ExpenseTran>
              </div>
              <!-- More Option Icon -->
              <div>
                <MoreOption
                  :key="item._id + 'MoreOption'"
                  :expenseInfo="item"
                ></MoreOption>
              </div>
            </base-row-layout>
          </template>
        </v-data-table>
        <!-- {{ isEditing }} -->
      </v-card-text>
      <v-card-actions>
        <v-speed-dial bottom left absolute direction="right" v-model="fab">
          <template v-slot:activator>
            <newExpense
              :loadFunction="loadAllClients"
              :OnEdite="OnEdite"
              :isEditing="isEditing"
              @input="isEditing = $event"
            >
            </newExpense>
          </template>
        </v-speed-dial>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import { printTable } from "@/Mixins/printTable";
import printJS from "print-js";

export default {
  mixins: [printTable],
  components: {
    newExpense: () => import("@/components/Branches/Expense/NewFixedExpense"),
    MoreOption: () => import("@/components/Branches/Expense/MoreInfo"),
    ShowBalance: () => import("@/components/util/showBalance.vue"),
    ExpenseTran: () => import("@/components/Branches/Expense/ExpenseTran.vue"),
    // ExpenseTran: () => import("@/components/util/TranSactionView.vue"),
  },
  data() {
    return {
      noData: "No Fixed Expense is availble",
      fab: false,
      isLoading: true,
      isEditing: false,
      OnEdite: {},
      CustomersList: [],
      search: "",
      headers: [
        {
          text: "Name",
          align: "left",
          value: "expensName",
        },
        { text: "Contact", value: "contact" },
        { text: "Expense", value: "expense" },
        { text: "Monthly Amount", value: "Amount" },

        {
          text: "More",
          value: "more",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["UsersToken"]),
    TotalFixeExpense() {
      return this.CustomersList.reduce(
        (total, { Amount }) => (total += Amount),
        0
      );
    },
  },
  methods: {
    PrintPage() {
      // console.log(this.UsersToken.UserBranch);
      let prHeader = [
        { value: "index", text: "#" },
        ...this.headers.filter(
          head =>
            head.text !== "Monthly Amount" &&
            head.text !== "More" &&
            head.text !== "Contact"
        ),
        { value: "Balance", text: "Balance" },
        { text: "Note", width: "150px" },
      ];
      let myTitle = `${this.UsersToken.UserBranch} expensis`;
      const myPrintTable = this.PrintReport(
        this.CustomersList.map(exp => ({
          ...exp,
          Balance: exp.EntryBook.reduce((rslt, crn) => {
            rslt += `${crn.AmountType || ""} =>  ${
              crn && crn.Balance > 0
                ? crn.Balance.toLocaleString()
                : "( " + Math.abs(crn.Balance).toLocaleString() + " )"
            }  \n`;
            return rslt;
          }, ""),
        })).reverse(),
        prHeader,
        myTitle.toUpperCase()
      );

      printJS({
        printable: myPrintTable,
        type: "html",
        style: this.CustomStyle("#249688", "#ffffff"),
        repeatTableHeader: false,
      });
    },
    EditeExpense(E_Supp) {
      // console.log(E_Supp);
      this.isEditing = true;
      this.OnEdite = E_Supp;
    },
    GetReq(url, query = {}) {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query,
      });
    },
    loadAllClients() {
      this.GetReq("/expense/fixed")
        .then(result => {
          // console.log(result);
          this.CustomersList = result.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    // HeaderIntialize() {
    //   return
    // }
  },

  created() {
    // this.headers = this.HeaderIntialize();

    this.loadAllClients();
  },
};
</script>
